const state = () => ({
  capByProvinceId: {},
})
const getters = {
  capList: (state) => (provinceId) => state.capByProvinceId[provinceId] || [],
}
const mutations = {
  receiveCapList(state, { provinceId, capList }) {
    state.capByProvinceId = {
      ...state.capByProvinceId,
      [provinceId]: capList,
    }
  },
}
const actions = {
  getCap({ commit, state }, provinceId) {
    if (state.capByProvinceId[provinceId]) {
      return Promise.resolve(state.capByProvinceId[provinceId])
    }
    return this.$axios
      .post('/akern-platform-backend/v1/common/cap/list', {
        provinceId,
      })
      .then((response) => {
        const capList = response.data.cap
        commit('receiveCapList', { provinceId, capList })
        return capList
      })
  },
}
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
